import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	patchDoneWorksControlMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PATCH_DONE_WORKS_CONTROL_METRIC,
	},
	patchDoneWorksControlMetricBulkUpdate: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PATCH_DONE_WORKS_CONTROL_METRIC_BULK_UPDATE,
	},
	getDoneWorksControlMetrics: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRICS,
	},
	getDoneWorksControlMetricPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC_PREVIEW,
	},
	getDoneWorksControlMetricPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC_POPUP,
	},
	createDoneWorksControlMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].CREATE_DONE_WORKS_CONTROL_METRIC,
	},
	getDoneWorksControlMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC,
	},
	putDoneWorksControlMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PUT_DONE_WORKS_CONTROL_METRIC,
	},
	deleteDoneWorksControlMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].DELETE_DONE_WORKS_CONTROL_METRIC,
	},
}